import { Component } from '@angular/core';

@Component({
    selector: 'app-upload-instruction',
    templateUrl: './upload-instruction.component.html',
    styleUrls: ['./upload-instruction.component.css'],
    standalone: false
})
export class UploadInstructionComponent {

}
